import React, { useMemo, useState, useRef } from 'react';
import { getFavoriteListsArray, getListImageUrl, compileListContentsString, isItemInList } from '@alltrails/shared/utils/listHelpers';
import { func, string, number, arrayOf, shape, object } from 'prop-types';
import * as styles from './styles/styles.module.scss';
import Modal from '../../shared/Modal';
import ListTableRow from './ListTableRow';
import CreateNewList from '../CreateNewList';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const ListsModal = ({ closeModal, type, ID, lists, listItems, handleModalFavoriteClick, handleModalListCreated }) => {
  const [edit, setEdit] = useState(false);
  const tableRef = useRef(null);

  const favoriteLists = useMemo(() => {
    return getFavoriteListsArray(lists);
  }, [lists]);

  const handleFavoriteClick = listId => {
    handleModalFavoriteClick(listId);
  };

  const handleListCreated = newList => {
    handleModalListCreated(newList);
    setEdit(false);
  };

  return (
    <Modal handleBackgroundClick={closeModal}>
      <div className={styles.container}>
        <button className={styles.closeButton} onClick={closeModal} type="button" label={StringConstantsMixin.strings.CLOSE} data-testid="close" />
        <h2 className={styles.saveToListTitle}>{StringConstantsMixin.strings.LIST_MODAL.SAVE_TO_LIST}</h2>
        <div className={styles.tableWrapper} ref={tableRef}>
          <table className={styles.table}>
            <tbody>
              {favoriteLists.map(list => {
                return (
                  <ListTableRow
                    key={list.id}
                    imgUrl={getListImageUrl(list.id)}
                    listTitle={list.title}
                    handleFavoriteClick={() => handleFavoriteClick(list.id)}
                    isFavorite={isItemInList(type, ID, listItems[list.id])}
                    listContents={compileListContentsString(list.id, listItems)}
                    isFavoriteRow={lists[0].title === list?.title}
                  />
                );
              })}
            </tbody>
          </table>
        </div>
        <CreateNewList
          edit={edit}
          handleEditClick={() => setEdit(true)}
          handleCancelClick={() => setEdit(false)}
          handleListCreated={handleListCreated}
          tableRef={tableRef}
        />
      </div>
    </Modal>
  );
};

ListsModal.propTypes = {
  closeModal: func.isRequired,
  type: string.isRequired,
  ID: number.isRequired,
  lists: arrayOf(shape({ id: number, title: string, order: number })),
  listItems: object,
  handleModalFavoriteClick: func.isRequired,
  handleModalListCreated: func.isRequired
};

ListsModal.defaultProps = {
  lists: [],
  listItems: {}
};

export default ListsModal;
